<button class='btn btn-primary' (click)="upgrade()">
    Upgrade to Pro
</button>